import { render, staticRenderFns } from "./PopupFooterOneButton.vue?vue&type=template&id=51e8893a&scoped=true"
import script from "./PopupFooterOneButton.vue?vue&type=script&lang=js"
export * from "./PopupFooterOneButton.vue?vue&type=script&lang=js"
import style0 from "./PopupFooterOneButton.vue?vue&type=style&index=0&id=51e8893a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8893a",
  null
  
)

export default component.exports